import { Box } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers/';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Dayjs } from 'dayjs';
import 'dayjs/locale/de';
import React, { FC, useEffect } from 'react';
import DayjsUtils from '../../utils/DayjsUtils';

interface DateRangePickerProps {
  onChange: (dateRange: Dayjs[]) => void;
}
const DateRangePicker: FC<DateRangePickerProps> = ({ onChange }: DateRangePickerProps) => {
  const [from, setFrom] = React.useState<Dayjs | null>(DayjsUtils.firstDayOfWeek());
  const [to, setTo] = React.useState<Dayjs | null>(DayjsUtils.todayEnd());
  const [days, setDays] = React.useState<Dayjs[]>([]);

  /*
   Based on user interactions, the state is updated, representing the range a user has selected.
   It is always rounded to the full day.
  */
  useEffect(() => {
    if (to && from) {
      const d = Math.ceil(to.diff(from, 'day', true));
      const newDays = Array.from({ length: d }, (_, i) => from.add(i, 'day'));
      setDays(newDays);
    }
  }, [from, to]);

  /*
  If the Date Range list changes, the changes are passed to the parent component.
  */
  useEffect(() => {
    onChange(days);
  }, [days]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 2,
      }}>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="de">
        <DatePicker
          label="Von"
          value={from}
          onChange={(newValue) => {
            setFrom(newValue);
          }}
        />
      </LocalizationProvider>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="de">
        <DatePicker
          label="Bis"
          value={to}
          onChange={(newValue) => {
            setTo(newValue);
          }}
        />
      </LocalizationProvider>
    </Box>
  );
};

export default DateRangePicker;
